//AWARD list
export const AWARD_LIST_REQUEST = 'AWARD_LIST_REQUEST';
export const AWARD_LIST_SUCCESS = 'AWARD_LIST_SUCCESS';
export const AWARD_LIST_FAIL = 'AWARD_LIST_FAIL';
